import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { createRoutine } from 'redux-saga-routines';
import { add } from 'ramda';

export const registerRoutine = createRoutine('AUTH_REGISTER');
export const loginRoutine = createRoutine('AUTH_LOGIN');
export const resetPasswordRoutine = createRoutine('AUTH_RESET_PASSWORD');
export const changePasswordRoutine = createRoutine('AUTH_CHANGE_PASSWORD');
export const updateUserDataRoutine = createRoutine('AUTH_UPDATE');

export const { Types: AuthTypes, Creators: AuthActions } = createActions(
  {
    listenForAuth: [],
    userAuthenticated: ['data', 'idToken'],
    userNotAuthenticated: [],
    authStateChanged: [],
    signInAnonymously: [],
    signOut: [],
    willReAuth: [],
    showModal: ['tab'],
    hideModal: [],
    initAuthMode: [],
    initAuthModeSuccess: ['mode', 'params'],
    clearAuthMode: [],
    changePassword: [],
    incrementAuthAttempts: [],
    clearAuthAttempts: [],
  },
  { prefix: 'AUTH_' }
);

export const INITIAL_STATE = Immutable({
  data: {},
  isAuthenticated: false,
  activeModal: false,
  authMode: null,
  authModeParams: {},
  authAttempts: 0,
});

const userAuthenticated = (state, { data }) => state.set('data', Immutable(data)).set('isAuthenticated', true);

const userNotAuthenticated = state => state.set('data', Immutable({})).set('isAuthenticated', false);

const showModal = (state, { tab }) => state.set('activeModal', tab);

const hideModal = state => state.set('activeModal', false);

const initAuthModeSuccess = (state, { mode, params }) => state.set('authMode', mode).set('authModeParams', params);

const clearAuthMode = state => state.set('authMode', null).set('authModeParams', {});

const incrementAuthAttempts = state => state.update('authAttempts', add(1));

const clearAuthAttempts = state => state.set('authAttempts', 0);

export const reducer = createReducer(INITIAL_STATE, {
  [AuthTypes.USER_AUTHENTICATED]: userAuthenticated,
  [AuthTypes.USER_NOT_AUTHENTICATED]: userNotAuthenticated,
  [AuthTypes.SHOW_MODAL]: showModal,
  [AuthTypes.HIDE_MODAL]: hideModal,
  [AuthTypes.INIT_AUTH_MODE_SUCCESS]: initAuthModeSuccess,
  [AuthTypes.CLEAR_AUTH_MODE]: clearAuthMode,
  [AuthTypes.INCREMENT_AUTH_ATTEMPTS]: incrementAuthAttempts,
  [AuthTypes.CLEAR_AUTH_ATTEMPTS]: clearAuthAttempts,
});
